import React from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import './loader.style.scss';

interface IProps {
  loading: boolean;
  children?: React.ReactNode;
}

const Loader: React.FC<IProps> = ({ loading, children }) => {
  const { t } = useTranslation();

  return (
    <div className="loader__wrapper">
      {loading && (
        <div className="loader__nested">
          <div className="loader__spinner"></div>
          <div className="loader__text">{t('common.loading')}</div>
        </div>
      )}
      <div
        className={clsx({
          loader__container: true,
          'loader__container--blur': loading,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default Loader;
